import React from 'react';

// NOTE: File is called ProductNumber deliberatly as calling it honeypot results in the classnames having honeypot in them.
import * as styles from './ProductNumber.module.scss';

export const honeyPotName = 'product-number';

interface props {
    value: string | number,
    onChange: (e: React.ChangeEvent<HTMLInputElement>)=> void
}

const Honeypot = ({ value, onChange }: props): JSX.Element => {
    return (
        <div className={styles.ProductNumber}>
            <label htmlFor={honeyPotName}>Don’t fill this out if you’re human:</label>
            <input value={value} onChange={onChange} type="text" name={honeyPotName} />
        </div>
    );
};

export default Honeypot;
